import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CONSTANTS } from '@pk/powerkioskutils';

export interface AuctionProduct {
	rfqSessionProductId?: FormControl<string>;
	type: FormControl<string>;
	term: FormControl<number>;
	greenPercentage: FormControl<number>;
	hidden?: FormControl<boolean>;
}

@Injectable({
	providedIn: 'root',
})
export class AuctionService {
	public getProductNote(products: FormArray<FormGroup<AuctionProduct>>): string {
		let note = '"Energy Only"';

		if (products.value.some(p => p.type === CONSTANTS.products.fixedAllInElectric)) {
			note += ' and "Fixed w/ Adjustment"';
		}

		return `${note} product(s) will be added automatically for each unique term + green percentage included in the new products getting added above if not already added.`;
	}
}
